module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_005.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_005.png
// module id = 1129
// module chunks = 0